<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>Adding IBAS User</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Full name*"
                      v-model="form.name"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Mobile Number*"
                      v-model="form.mobileNumber"
                      v-mask="'+63 ### #### ###'"
                      masked="false"
                      type="tel"
                      placeholder="+63 XXX XXXX XXX"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      :append-icon="show.password ? 'mdi-eye' : 'mdi-eye-off'"
                      label="Password*"
                      :type="show.password ? 'text' : 'password'"
                      v-model="form.password"
                      :rules="rules.password"
                      v-mask="'######'"
                      masked="false"
                      @click:append="show.password = !show.password"
                      max="6"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="roles"
                      label="Role"
                      :rules="rules.required"
                      @change="selectRole($event)"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click.native="cancel()">
                Close
              </v-btn>
              <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <Snackbar></Snackbar>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import Snackbar from "../Snackbar.vue";
export default {
  name: "AddIbasUserDialog",
  components: {
    Snackbar,
  },
  // props: ["dialog"],
  data() {
    return {
      show: {
        password: false,
      },

      roles: ["Full access", "P2P", "Installer"],
      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
        password: [
          (value) =>
            (value && value.length >= 6) || "Password at least 6 characters",
          (value) =>
            (value && value.length <= 6) ||
            "Password must be less than 6 characters",
        ],
      },

      form: {
        mobileNumber: "",
        name: "",
        password: "",
        active: true,
        th: false,
        territoryHead: 0,
        installer: false,
        ibasP2P: false,
        fromDealer: true,
      },

      dialog: false,
      resolve: null,
      reject: null,
      // message: null,
      // title: null,
      // options: {
      //   color: "grey lighten-3",
      //   width: 400,
      //   zIndex: 200,
      //   noconfirm: false,
      // },
    };
  },
  methods: {
    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;
      let data = this.form;

      const { adminLogin } = this.$store.getters.userData;

      data.mobileNumber = this.trimMobileNumber(data.mobileNumber);
      data.territoryHead = adminLogin._id;
      await this.$api
        .post("/dashboard-acquisition-login", data)
        .then(() => {
          // console.log(response);
          // this.$emit("response", true);
          this.loadingBtn = false;

          setTimeout(() => {
            this.$refs.form.reset();
          }, 500);
          this.agree();
          this.$store.dispatch(
            "addSnackbarMessage",
            "IBAS user is successfully added."
          );
          this.$store.dispatch("addSnackbar", true);
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },

    open() {
      this.dialog = true;
      // this.getRetailerSales(data.retailerId);
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },

    cancel() {
      this.resolve(false);
      this.dialog = false;
    },

    // closeDialog() {
    //   this.$emit("close", false);
    //   this.$refs.form.reset();
    // },

    formatDate(d, format = "YYYY-MM-DD HH:mm:ss") {
      return moment(d).format(format);
    },

    trimMobileNumber(num) {
      return num.replace(/\s+/g, "").replace("+", "");
    },

    selectRole(e) {
      if (e === "Full access") {
        this.form.installer = false;
        this.form.ibasP2P = false;
      }

      if (e === "P2P") {
        this.form.installer = false;
        this.form.ibasP2P = true;
      }

      if (e === "Installer") {
        this.form.installer = true;
        this.form.ibasP2P = false;
      }
    },
  },

  created() {
    // this.getLocation();
  },

  computed: {
    userData() {
      return this.$store.getters.userData;
    },
  },
};
</script>
